<template>
    <button @click="exportExcel">
        <slot></slot>
    </button>
</template>

<script>
import XLSX from 'xlsx/xlsx'

export default {
    name: 'ExportExcelUpdated',

    props: {
        sheets: {
            type: Array,
            required: true
        },

        filename: {
            type: String,
            default: 'excel'
        },

        sheetname: {
            type: String,
            default: 'SheetName'
        }
    },
    data() {
        return {}
    },
    methods: {
        newSheet() {
            return [
                {
                    sheetname: '',
                    columns: [],
                    data: []
                }
            ]
        },

        exportExcel() {
            let vm = this

            let wb = XLSX.utils.book_new()

            vm.sheets.forEach(function (sheet, sheetIndex) {
                let createXLSLFormatObj = []
                let newXlsHeader = []
                if (sheet.columns.length === 0) {
                    return
                }
                if (sheet.data.length === 0) {
                    return
                }
                sheet.columns.forEach(function (value, index) {
                    newXlsHeader.push(value.title)
                })

                createXLSLFormatObj.push(newXlsHeader)
                sheet.data.forEach(function (value, index) {
                    let innerRowData = []
                    sheet.columns.forEach(function (val, index) {
                        if (val.dataFormat && typeof val.dataFormat === 'function') {
                            if (val.useRow) {
                                if (val.extraData) {
                                    innerRowData.push(val.dataFormat(value, val.extraData))
                                } else {
                                    innerRowData.push(val.dataFormat(value))
                                }
                            } else {
                                if (val.value.includes('.')) {
                                    let split = val.value.split('.')

                                    let finalVal = value
                                    for (let i = 0; i < split.length; i++) {
                                        if (finalVal) {
                                            finalVal = finalVal[split[i]] || ''
                                        }
                                    }

                                    innerRowData.push(val.dataFormat(finalVal))
                                } else {
                                    innerRowData.push(val.dataFormat(value[val.value]))
                                }
                            }
                        } else {
                            if (val.value.includes('.')) {
                                let split = val.value.split('.')

                                let finalVal = value
                                for (let i = 0; i < split.length; i++) {
                                    if (finalVal) {
                                        finalVal = finalVal[split[i]] || ''
                                    }
                                }

                                innerRowData.push(finalVal)
                            } else {
                                innerRowData.push(value[val.value])
                            }
                        }
                    })
                    createXLSLFormatObj.push(innerRowData)
                })

                let ws = XLSX.utils.aoa_to_sheet(createXLSLFormatObj)
                let ws_name = sheet.sheetname
                XLSX.utils.book_append_sheet(wb, ws, ws_name)
            })

            let filename = vm.filename + '.xlsx'

            XLSX.writeFile(wb, filename)
            this.$emit('completed')
        }
    },
    created() {
        this.exportExcel()
    }
}
</script>
